/* MOOOD — product page: gallery, zoom, variants, Tabby promo (vanilla JS) */
(function () {
  if (customElements.get('moood-product')) return;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------------- Tabby promo (lazy-loaded third-party script) ---------------- */
  var tabbyLoading = null;
  function loadTabby() {
    if (window.TabbyPromo) return Promise.resolve();
    if (tabbyLoading) return tabbyLoading;
    tabbyLoading = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = 'https://checkout.tabby.ai/tabby-promo.js';
      s.async = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return tabbyLoading;
  }
  function renderTabby(slot) {
    if (!slot) return;
    loadTabby().then(function () {
      slot.innerHTML = '';
      try {
        /* global TabbyPromo */
        new TabbyPromo({
          selector: '#' + slot.id,
          currency: slot.dataset.currency,
          price: parseFloat(slot.dataset.price).toFixed(2),
          installmentsCount: parseInt(slot.dataset.installments, 10) || 4,
          lang: slot.dataset.lang,
          source: 'product',
          publicKey: slot.dataset.key,
          merchantCode: slot.dataset.merchant
        });
      } catch (e) {}
    }).catch(function () {});
  }

  class MooodProduct extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.sectionId = this.dataset.sectionId;
      this.track = $('[data-gallery-track]', this);
      this.thumbs = $$('[data-thumb]', this);
      this.dots = $$('.gallery__dots span', this);
      this.zoom = $('[data-zoom-dialog]', this);
      try { this.data = JSON.parse($('[data-product-json]', this).textContent); } catch (e) { this.data = { variants: [] }; }

      this.initGallery();
      this.initZoom();
      this.initVariants();
      this.initTabby();
    }

    /* ---------------- Gallery ---------------- */
    initGallery() {
      var self = this;
      if (!this.track) return;
      this.thumbs.forEach(function (b) {
        b.addEventListener('click', function () { self.goTo(parseInt(b.dataset.thumb, 10)); });
      });
      var raf;
      this.track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var w = self.track.clientWidth || 1;
          var idx = Math.round(Math.abs(self.track.scrollLeft) / w);
          self.setActive(idx);
        });
      }, { passive: true });

      // Desktop hover zoom (lens-less: scales the image following the pointer)
      if (window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
        $$('.gallery__slide', this.track).forEach(function (slide) {
          var img = $('img', slide);
          if (!img) return;
          slide.addEventListener('mouseenter', function () { slide.classList.add('is-zooming'); });
          slide.addEventListener('mouseleave', function () { slide.classList.remove('is-zooming'); img.style.transformOrigin = ''; });
          slide.addEventListener('mousemove', function (e) {
            var r = slide.getBoundingClientRect();
            img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
          });
        });
      }
    }

    goTo(idx, smooth) {
      var slide = $$('.gallery__slide', this.track)[idx];
      if (!slide) return;
      var dir = document.documentElement.dir === 'rtl' ? -1 : 1;
      this.track.scrollTo({ left: dir * slide.offsetWidth * idx, behavior: smooth === false ? 'auto' : 'smooth' });
      this.setActive(idx);
    }

    setActive(idx) {
      this.thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
      this.dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }

    /* ---------------- Zoom dialog ---------------- */
    initZoom() {
      var self = this;
      if (!this.zoom) return;
      $$('[data-zoom-open]', this).forEach(function (b) {
        b.addEventListener('click', function () { self.openZoom(parseInt(b.dataset.zoomOpen, 10), b); });
      });
      $('[data-zoom-close]', this.zoom).addEventListener('click', function () { self.closeZoom(); });
      this.zoom.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.stopPropagation(); self.closeZoom(); }
        if (e.key === 'Tab') { e.preventDefault(); $('[data-zoom-close]', self.zoom).focus(); }
      });
    }

    openZoom(idx, trigger) {
      this.zoomTrigger = trigger;
      this.zoom.classList.add('is-open');
      this.zoom.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-locked');
      if (window.theme && theme.processKnockouts) theme.processKnockouts(this.zoom);
      var item = $('[data-zoom-item="' + idx + '"]', this.zoom);
      var scroller = $('.zoom-dialog__scroll', this.zoom);
      requestAnimationFrame(function () {
        if (item) scroller.scrollTop = item.offsetTop - 48;
        scroller.scrollLeft = (scroller.scrollWidth - scroller.clientWidth) / 2 * (document.documentElement.dir === 'rtl' ? -1 : 1);
      });
      $('[data-zoom-close]', this.zoom).focus();
    }

    closeZoom() {
      this.zoom.classList.remove('is-open');
      this.zoom.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-locked');
      if (this.zoomTrigger) this.zoomTrigger.focus();
    }

    /* ---------------- Variants ---------------- */
    initVariants() {
      var picker = $('[data-variant-picker]', this);
      if (!picker) return;
      var self = this;
      picker.addEventListener('change', function () { self.onVariantChange(picker); });
      this.markAvailability(picker);
    }

    selectedOptions(picker) {
      var groups = $$('fieldset', picker);
      return groups.map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
    }

    markAvailability(picker) {
      var selected = this.selectedOptions(picker);
      var variants = this.data.variants;
      $$('fieldset', picker).forEach(function (fs, oi) {
        $$('input', fs).forEach(function (input) {
          var ok = variants.some(function (v) {
            if (!v.available || v.options[oi] !== input.value) return false;
            return v.options.every(function (val, j) { return j === oi || val === selected[j]; });
          });
          input.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    onVariantChange(picker) {
      var opts = this.selectedOptions(picker);
      var variant = this.data.variants.find(function (v) {
        return v.options.every(function (val, i) { return val === opts[i]; });
      });
      this.markAvailability(picker);
      var idInput = $('[data-variant-id]', this);
      var btn = $('button[name="add"]', this);
      if (!variant) {
        if (btn) { btn.disabled = true; var lbl = btn.querySelector('.btn-cart__label') || btn; lbl.textContent = (window.theme && theme.strings.unavailable) || ''; }
        return;
      }
      if (idInput) idInput.value = variant.id;

      // Update URL (shareable, keeps Back working)
      try {
        var u = new URL(location.href);
        u.searchParams.set('variant', variant.id);
        history.replaceState(history.state, '', u.toString());
      } catch (e) {}

      // Jump gallery to the variant image
      if (variant.featured_media) {
        var slide = $('.gallery__slide[data-media-id="' + variant.featured_media + '"]', this);
        if (slide) this.goTo(parseInt(slide.dataset.index, 10));
      }

      // Re-render price, specs, buy row and WhatsApp link with the Section Rendering API
      var self = this;
      var url = this.dataset.productUrl + '?variant=' + variant.id + '&section_id=' + this.sectionId;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        $$('[data-rerender]', self).forEach(function (el) {
          var fresh = doc.querySelector('[data-rerender="' + el.dataset.rerender + '"]');
          if (!fresh) return;
          if (el.dataset.rerender.indexOf('buy-') === 0) {
            // keep the typed quantity
            var q = $('input[name="quantity"]', el);
            var qv = q ? q.value : null;
            el.innerHTML = fresh.innerHTML;
            if (qv) { var q2 = $('input[name="quantity"]', el); if (q2) q2.value = qv; }
          } else if (el.tagName === 'A') {
            el.href = fresh.href;
          } else {
            el.innerHTML = fresh.innerHTML;
          }
        });
        var slot = $('[data-tabby]', self);
        var freshSlot = doc.querySelector('[data-tabby]');
        if (slot && freshSlot && slot.dataset.price !== freshSlot.dataset.price) {
          slot.dataset.price = freshSlot.dataset.price;
          renderTabby(slot);
        }
      }).catch(function () {
        if (btn) { btn.disabled = !variant.available; }
      });
    }

    /* ---------------- Tabby ---------------- */
    initTabby() {
      var slot = $('[data-tabby]', this);
      if (!slot) return;
      if (!('IntersectionObserver' in window)) { renderTabby(slot); return; }
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); renderTabby(slot); }
      }, { rootMargin: '200px' });
      io.observe(slot);
    }
  }

  customElements.define('moood-product', MooodProduct);
})();
